import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const getDrones = (customerId, page, pageSize) => {
    return handler.get(`drones/list/${customerId}?page=${page}&pageSize=${pageSize}`);
};
const getDronesOnline = (page, pageSize, type, number) => {
    let params = `?page=${page}&pageSize=${pageSize}`;
    if (type !== null) {
        params += `&type=${type}`;
    }
    if (number !== null) {
        params += `&number=${number}`;
    }
    return handler.get(`drones/online/${params}`);
};
const getDrone = (droneId) => {
    return handler.get(`drones/${droneId}`);
};
const addDrone = (model) => {
    return handler.post(`drones`, model);
};
const editDrone = (droneId, model) => {
    return handler.put(`drones/${droneId}`, model);
};
const updateDroneCustomer = (droneId, customerId) => {
    return handler.put(`drones/${droneId}/move/${customerId}`);
};
const deleteDrone = (droneId) => {
    return handler.delete(`drones/${droneId}`);
};
const getDroneUsers = (droneId) => {
    return handler.get(`drones/${droneId}/users`);
};
const assignDroneUser = (userId, droneId) => {
    return handler.put(`drones/${droneId}/assign/${userId}`);
};
const unAssignDroneUser = (userId, droneId) => {
    return handler.put(`drones/${droneId}/unassign/${userId}`);
};
export default {
    getDrones,
    getDronesOnline,
    getDrone,
    addDrone,
    editDrone,
    updateDroneCustomer,
    deleteDrone,
    getDroneUsers,
    assignDroneUser,
    unAssignDroneUser,
};
